/**
 * Common helpers for CSV/PDF exports (`src/api/RequestV2` + legacy GET/POST shapes).
 */

export function extractExportRows(res, { method = "post", useV2 = false } = {}) {
  if (method === "post") {
    if (useV2) {
      const root = res ?? {};
      const content = root?.content ?? root?.data?.content ?? root?.metaInfo?.mandates ?? root;
      if (Array.isArray(content)) return content;
      return content ? [content] : [];
    }
    const root = res?.data ?? res ?? {};
    const content = root?.content ?? root;
    if (Array.isArray(content)) return content;
    return content ? [content] : [];
  }

  const root = res?.data ?? res ?? [];
  if (Array.isArray(root)) return root;
  const content = root?.content ?? root?.data?.content;
  if (Array.isArray(content)) return content;
  return root ? [root] : [];
}
